import { Dialog } from "primereact/dialog";
import { FileUpload } from "primereact/fileupload";

export default function ImportacaoDialog({ onHide, onUpload, visible }) {
    return (
        <Dialog
            header="Nova Importação"
            onHide={onHide}
            visible={visible}
        >
            <FileUpload
                accept=".csv, .xlsx"
                customUpload
                uploadLabel="Enviar"
                uploadHandler={onUpload}
            />
        </Dialog>
    );
}
